module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAA3XAAAN1wFCKJt4AAAAB3RJTUUH4gMHBzMqZ7DoIwAAAKZJREFUaN7t2NENgCAMRVGfmzqEDqFDOKpugBVKKHDfNzE5QQrtshBSJfL+4HZcj2Xdfe4KC7EiamDUAlADtHJGnHbDa1cUAeGBGebXAgIECBAgQIAAAQKExmquxipSz+42xcjFeE1ShhkHUbWARC2/wxx2j3ukafn1Hs6VohQFUApSNEAuSJERfzCKjrBi1APCglEviC+MekKkMLy1gACZBEIISecFj49MRPQNe2QAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/components/Header/user.png
// module id = 523
// module chunks = 4